/**
 * floating-cart.ts — плавающая корзина (sticky indicator under header)
 * Проект: TorgiRT (shared — все витрины)
 */

import { state, refs } from './state';
import { isCartAllowedPage, formatMoney, getCartTotal } from './helpers';
import { syncSfNotifyTop } from './toast';

export function updateFloatingCartText(): void {
  if (!refs.cartSummaryFloating || !refs.cartSummaryFloatingText) return;
  if (state.cart.length === 0 || !isCartAllowedPage()) {
    refs.cartSummaryFloating.classList.add("is-hidden-floating");
    syncSfNotifyTop();
    return;
  }
  refs.cartSummaryFloatingText.textContent =
    "Корзина: итого " + formatMoney(getCartTotal());
}

let _floatingRafId = 0;

export function updateFloatingCartVisibility(): void {
  if (!refs.cartSummaryFloating || !refs.cartSummary) return;
  if (state.cart.length === 0 || !isCartAllowedPage()) {
    refs.cartSummaryFloating.classList.add("is-hidden-floating");
    syncSfNotifyTop();
    return;
  }
  const summaryRect = refs.cartSummary.getBoundingClientRect();
  const headerHeight = (document.querySelector(".site-header") as HTMLElement)?.offsetHeight ?? 0;
  const mainSummaryHidden = summaryRect.bottom < headerHeight;

  refs.cartSummaryFloating.style.top = headerHeight + "px";
  refs.cartSummaryFloating.style.setProperty('--floating-cart-inset-top', headerHeight + 'px');

  if (mainSummaryHidden && window.scrollY > 40) {
    refs.cartSummaryFloating.classList.remove("is-hidden-floating");
  } else {
    refs.cartSummaryFloating.classList.add("is-hidden-floating");
  }
  syncSfNotifyTop();
}

export function initFloatingCartScroll(): void {
  function scheduleUpdate(): void {
    if (_floatingRafId) return;
    _floatingRafId = requestAnimationFrame(function () {
      _floatingRafId = 0;
      updateFloatingCartVisibility();
    });
  }
  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate, { passive: true });
  scheduleUpdate();
}
